import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../wf/client';
import { BrowserRouter as Router } from 'react-router-dom';
import RedemptionEditor from './RedemptionEditor';
import SaveRedemptionBenefit from './SaveRedemptionBenefit';
import { waitForNetworkIdle } from '@withfriendsco/wf-components';
const RedemptionAppGate = ({ children }) => {
    const [isCleared, setIsCleared] = useState(false);
    useEffect(() => {
        let mounted = true;
        const run = async () => {
            try {
                await waitForNetworkIdle().catch(() => { });
                await client.clearStore();
            }
            finally {
                if (mounted)
                    setIsCleared(true);
            }
        };
        run();
        return () => { mounted = false; };
    }, []);
    if (!isCleared)
        return null;
    return _jsx(_Fragment, { children: children });
};
const RedemptionApp = ({ id, businessId }) => {
    return (_jsx(ApolloProvider, { client: client, children: _jsx(RedemptionAppGate, { children: _jsx(Router, { children: _jsx("div", { id: "tw-root", children: _jsx("div", { id: "tw-main", className: "App container text-center", children: _jsxs("div", { className: "flex flex-wrap justify-center font-sans", children: [_jsx(RedemptionEditor, { id: id }), _jsx("div", { className: "w-full" }), _jsx(SaveRedemptionBenefit, { id: id, fromOnboarding: false })] }) }) }) }) }) }));
};
export default RedemptionApp;
